module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/facebook-3c17d7df48c6930d8f4bc88b9b0ad734.svg";